module.exports = __webpack_public_path__ + "img/ICONR_DT.e190809b.png";